import axios from '../library/axios'
import { MySwal } from "../library/swal";
import { setHrefWithSlugHook, } from "../config/routes/guards/slug";
import { getSlug, } from "../config/routes/guards/slug";
import { getApiErrorMessage } from "./apiErrorMessage";
import { isApiDebugEnabled, logApiError } from "./apiDebug";

export const validationAccess = async (namaModule) => {
  if (!namaModule) return;
  const requestBody = {
    namaModule: namaModule,
  };
  return axios({
    url: "/users/validasi-akses",
    method: "POST",
    data: requestBody,
    headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
  })
    .catch((err) => {
      // Sesi habis (401 tanpa kode) & akses ditolak (403) sudah ditangani
      // beserta pesannya oleh interceptor axios.
      if (err?.isHandledByInterceptor) return;

      const status = err?.response?.status;
      const code = err?.response?.data?.code;
      const message = getApiErrorMessage(err);

      logApiError(err, { sumber: 'validasi-akses', namaModule });

      // Mode debug: tahan logout supaya error sempat dibaca di console.
      if (isApiDebugEnabled()) {
        MySwal.fire({
          icon: 'info',
          title: 'Mode Debug — Logout Ditahan',
          text: `Validasi akses gagal (${status || 'tanpa balasan'}). Cek console: speakDebug.last()`,
        });
        return;
      }

      // User memang tidak punya hak akses ke modul ini -> keluarkan.
      if (status === 401 && code === 'ACCESS_DENIED') {
        MySwal.fire({
          icon: "warning",
          title: "Akses Ditolak",
          text: message,
        });
        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          setHrefWithSlugHook('/login');
        }, 3000);
        return;
      }

      // Gangguan server / jaringan: sesi user MASIH SAH.
      // Sebelumnya semua error di sini memicu logout paksa disertai pesan
      // "undefined", padahal penyebabnya hanya server sedang terganggu.
      console.error('[validasi-akses] gagal memeriksa akses modul:', status, message);
      MySwal.fire({
        icon: "warning",
        title: "Validasi Akses Tertunda",
        text: `${message} Anda tidak perlu login ulang.`,
      });
    });
};
